module.exports = __webpack_public_path__ + "img/checkup-bg.15961599.png";